import type { ServiceLabel } from './types';

/** Cayman Island is single-service-only per the legacy config. Extend as needed. */
export const CAYMAN_SERVICES: readonly ServiceLabel[] = [
  { key: 'Other', label: 'Other', jurisdiction: 'Cayman Island' },
] as const;